const identifierValues = (value) =>
  (Array.isArray(value) ? value : [value])
    .flatMap((item) => String(item ?? "").split(/[;,]/))
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);

export const adviserIoDetailsDocumentId = (adviser = {}) =>
  String(
    adviser.adviserId ||
      adviser.documentId ||
      adviser.docId ||
      adviser.email ||
      adviser.id ||
      "",
  ).trim();

export const adviserIoRecipientIds = (ioDetails = {}) => [
  ...new Set(
    [
      ioDetails.ioAdviserId,
      ioDetails.id,
      ioDetails.groupId,
      ioDetails.userId,
      ioDetails.ioGroupId,
      ioDetails.ioUserId,
    ].flatMap(identifierValues),
  ),
];

export const uniqueIoRecipientIdsByEmail = (entries = []) => {
  const candidates = new Map();
  entries.forEach(({ email, ioDetails, isAppointed, adviser }) => {
    adviserIoRecipientIds(ioDetails).forEach((id) => {
      const owners = candidates.get(id) || new Map();
      owners.set(email, {
        email,
        isAppointed:
          isAppointed ?? adviser?.isAppointed ?? !adviser?.isUnappointed,
      });
      candidates.set(id, owners);
    });
  });

  const owners = new Map(
    [...candidates].map(([id, candidatesByEmail]) => {
      const possibleOwners = [...candidatesByEmail.values()];
      const appointedOwners = possibleOwners.filter(
        (candidate) => candidate.isAppointed !== false,
      );
      const preferredOwners = appointedOwners.length
        ? appointedOwners
        : possibleOwners;
      return [
        id,
        preferredOwners.length === 1 ? preferredOwners[0].email : null,
      ];
    }),
  );

  return Object.fromEntries(
    entries.map(({ email, ioDetails }) => [
      email,
      adviserIoRecipientIds(ioDetails).filter((id) => owners.get(id) === email),
    ]),
  );
};

